import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowRightSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-right-square"} maskId="square-filled-radius-0-stroke-1-IconArrowRightSquare"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM12.293 8.5L15.293 11.5H7V12.5H15.293L12.293 15.5L13 16.207L17.207 12L13 7.79297L12.293 8.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowRightSquare;
